<div class="header-footer-container">
    <div class="page-header">
        <h1 class="page-title">Antet și Subsol Documente</h1>
        <p class="page-description">Gestionați anteturile și subsolurile pentru documentele generate</p>
    </div>

    <mat-tab-group [(selectedIndex)]="selectedTabIndex">
        <!-- Tab Antete (Headers) -->
        <mat-tab label="Antete">
            <div class="tab-content">
                <div class="d-flex justify-content-between align-items-center mb-3 mt-3">
                    <h3 class="tab-title m-0">Lista Antete</h3>
                    <button mat-raised-button class="add-button" (click)="openAddHeaderDialog()">
                        <mat-icon>add</mat-icon>
                        Adaugă Antet
                    </button>
                </div>

                <div class="table-responsive">
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Denumire</th>
                                <th>Tip Conținut</th>
                                <th>Aliniere</th>
                                <th>Mod Afișare</th>
                                <th class="text-center">Default</th>
                                <th class="text-center">Activ</th>
                                <th class="text-center">Acțiuni</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let header of headers">
                                <td>
                                    {{ header.name }}
                                    <span *ngIf="header.is_default" class="badge bg-success ms-2">DEFAULT</span>
                                </td>
                                <td>{{ getContentTypeLabel(header.content_type) }}</td>
                                <td>{{ getAlignmentLabel(header.alignment) }}</td>
                                <td>{{ getDisplayModeLabel(header.display_mode) }}</td>
                                <td class="text-center">
                                    <mat-icon [class.text-success]="header.is_default"
                                        [class.text-muted]="!header.is_default">
                                        {{ header.is_default ? 'star' : 'star_border' }}
                                    </mat-icon>
                                </td>
                                <td class="text-center">
                                    <mat-icon [class.text-success]="header.is_active"
                                        [class.text-danger]="!header.is_active">
                                        {{ header.is_active ? 'check_circle' : 'cancel' }}
                                    </mat-icon>
                                </td>
                                <td class="text-center">
                                    <ng-container
                                        *ngTemplateOutlet="actionsHeaderTemplate; context: { row: header }"></ng-container>
                                </td>
                            </tr>
                            <tr *ngIf="headers.length === 0 && !isLoading">
                                <td colspan="7" class="text-center text-muted py-4">
                                    Nu există antete definite. Adăugați primul antet.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </mat-tab>

        <!-- Tab Subsoluri (Footers) -->
        <mat-tab label="Subsoluri">
            <div class="tab-content">
                <div class="d-flex justify-content-between align-items-center mb-3 mt-3">
                    <h3 class="tab-title m-0">Lista Subsoluri</h3>
                    <button mat-raised-button class="add-button" (click)="openAddFooterDialog()">
                        <mat-icon>add</mat-icon>
                        Adaugă Subsol
                    </button>
                </div>

                <div class="table-responsive">
                    <table class="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Denumire</th>
                                <th>Tip Conținut</th>
                                <th>Aliniere</th>
                                <th class="text-center">Paginare</th>
                                <th class="text-center">Default</th>
                                <th class="text-center">Activ</th>
                                <th class="text-center">Acțiuni</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let footer of footers">
                                <td>
                                    {{ footer.name }}
                                    <span *ngIf="footer.is_default" class="badge bg-success ms-2">DEFAULT</span>
                                </td>
                                <td>{{ getContentTypeLabel(footer.content_type) }}</td>
                                <td>{{ getAlignmentLabel(footer.alignment) }}</td>
                                <td class="text-center">
                                    <span *ngIf="footer.show_pagination" class="badge bg-info">
                                        {{ footer.pagination_format }}
                                    </span>
                                    <span *ngIf="!footer.show_pagination" class="text-muted">-</span>
                                </td>
                                <td class="text-center">
                                    <mat-icon [class.text-success]="footer.is_default"
                                        [class.text-muted]="!footer.is_default">
                                        {{ footer.is_default ? 'star' : 'star_border' }}
                                    </mat-icon>
                                </td>
                                <td class="text-center">
                                    <mat-icon [class.text-success]="footer.is_active"
                                        [class.text-danger]="!footer.is_active">
                                        {{ footer.is_active ? 'check_circle' : 'cancel' }}
                                    </mat-icon>
                                </td>
                                <td class="text-center">
                                    <ng-container
                                        *ngTemplateOutlet="actionsFooterTemplate; context: { row: footer }"></ng-container>
                                </td>
                            </tr>
                            <tr *ngIf="footers.length === 0 && !isLoading">
                                <td colspan="7" class="text-center text-muted py-4">
                                    Nu există subsoluri definite. Adăugați primul subsol.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>

    <!-- Loading Spinner -->
    <div class="loading-overlay" *ngIf="isLoading">
        <mat-spinner></mat-spinner>
    </div>
</div>

<!-- Actions Template for Headers -->
<ng-template #actionsHeaderTemplate let-row="row">
    <div class="btn-group btn-group-sm">
        <button mat-icon-button color="primary" matTooltip="Editare" (click)="openEditHeaderDialog(row)">
            <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button [color]="row.is_default ? 'primary' : ''" matTooltip="Setează ca Default"
            (click)="setHeaderDefault(row)" [disabled]="row.is_default">
            <mat-icon>star</mat-icon>
        </button>
        <button mat-icon-button [color]="row.is_active ? 'primary' : 'warn'" matTooltip="Activează/Dezactivează"
            (click)="toggleHeaderActive(row)" [disabled]="row.is_default && row.is_active">
            <mat-icon>{{ row.is_active ? 'toggle_on' : 'toggle_off' }}</mat-icon>
        </button>
        <button mat-icon-button color="warn" matTooltip="Șterge" (click)="deleteHeader(row)"
            [disabled]="row.is_default">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</ng-template>

<!-- Actions Template for Footers -->
<ng-template #actionsFooterTemplate let-row="row">
    <div class="btn-group btn-group-sm">
        <button mat-icon-button color="primary" matTooltip="Editare" (click)="openEditFooterDialog(row)">
            <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button [color]="row.is_default ? 'primary' : ''" matTooltip="Setează ca Default"
            (click)="setFooterDefault(row)" [disabled]="row.is_default">
            <mat-icon>star</mat-icon>
        </button>
        <button mat-icon-button [color]="row.is_active ? 'primary' : 'warn'" matTooltip="Activează/Dezactivează"
            (click)="toggleFooterActive(row)" [disabled]="row.is_default && row.is_active">
            <mat-icon>{{ row.is_active ? 'toggle_on' : 'toggle_off' }}</mat-icon>
        </button>
        <button mat-icon-button color="warn" matTooltip="Șterge" (click)="deleteFooter(row)"
            [disabled]="row.is_default">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</ng-template>